import React, { useState, useEffect } from 'react'
import axiosInstance, { wpAxios } from '../../config/axiosResolver'
import axios from 'axios'
import { get, find } from 'lodash'
import { buildSubmissionsQuery, runCreateSubmission } from './createSubmissionFlow'
import { isAdmin } from '../../utils'
import { defaultSectionData } from '../single-submission/components/AdditionalInfo/constants'

import SubmissionsDashboard from './submissions-dashboard'

const SubmissionsDashboardContainer = (props) => {
  const { user } = props
  const [submissions, setSubmissions] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [loadError, setLoadError] = useState(null)
  const [reloadKey, setReloadKey] = useState(0)
  const [page, setPage] = useState(1)
  const [filters, setFilters] = useState({ordering: '-id', submit_email: props.match.params.email, page: page, status: props.location.search ? 'collection' : '' })
  const [notFilters, setNotFilters] = useState({ status: 'collection' })
  const [totalSubmissions, setTotalSubmissions] = useState(0)
  const [vendorUser, setVendorUser] = useState({})
  const isLbb = get(vendorUser, 'is_active', '0') !== '0'
  const isProfile = get(vendorUser, 'vendor_profile.is_active', '0') !== '0'
  const quickSubmissions = get(vendorUser, 'quick_submissions', 0)
  const canQuickSubmit = (isLbb || isProfile) && quickSubmissions > 0
  const totalQuickSubmissions = get(vendorUser, 'quick_submissions', 0)

  if (!isAdmin(user) && props.match.params.email !== user.email) props.history.push(`/submissions/dashboard/${user.email}`)

  useEffect(() => {
    // STY-730: a failed list load used to leave the page blank forever.
    const fetchData = () => {	
      setLoadError(null)
      axiosInstance
        .get(`/submissions/?${buildSubmissionsQuery(filters, notFilters)}`)
        .then((result) => {
          setSubmissions(result.data.results)
          setIsLoading(false)
          setTotalSubmissions(result.data.count)
          axios
            .get(`https://www.stylemepretty.com/api/v2/vendor/user/${encodeURIComponent(props.match.params.email)}`)
            .then((res) => {
              setVendorUser(res.data.data)
            })
            .catch(() => {})
        })
        .catch(() => {
          setIsLoading(false)
          setLoadError("We couldn't load your submissions.")
        })
    }

    fetchData()
  }, [filters, notFilters, props.match.params.email, reloadKey])

  const seedAdditionalInfo = (id, type) => {
    const defaultData = find(defaultSectionData, ['type', type])
    if (!(id > 358705 && defaultData)) return null
    return wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/${id}/save-additional-info`, {
      data: {
        type: 'default',
        leadImage: null,
        sections: get(defaultData, 'sections', []),
        title: get(defaultData, 'title', ''),
        subtitle: get(defaultData, 'subtitle', '')
      }
    })
  }

  // STY-730: both create flows return { ok, error } so the modal can show a
  // failure and re-enable its button; a follow-up failure still opens the
  // submission rather than leaving an orphan.
  const createSubmission = (data) => runCreateSubmission({
    create: () => axiosInstance.post(`/submissions/`, {
      title: data.title,
      type: data.type,
      status: data.status
    }).then((result) => result.data.id),
    followUps: (id) => [
      !isAdmin(user) ? seedAdditionalInfo(id, get(data, 'type')) : null,
      data.workshopHost ? wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/${id}/set-workshop-data`, { host: data.workshopHost }) : null
    ].filter(Boolean),
    navigate: (id) => props.history.push(`/submissions/submission/${id}`)
  })

  const createQuickSubmission = (data) => runCreateSubmission({
    before: () => wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/quick/decrement`, { id: get(vendorUser, 'id') }),
    create: () => axiosInstance.post(`/submissions/`, {
      title: data.title,
      type: data.type,
      description: `${data.gallery}${data.password ? ': ' + data.password : ''}`,
      status: 'quick'
    }).then((result) => result.data.id),
    followUps: (id) => [
      seedAdditionalInfo(id, get(data, 'type')),
      data.workshopHost ? wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/${id}/set-workshop-data`, { host: data.workshopHost }) : null,
      wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/set-quick`, { id: id })
    ].filter(Boolean),
    navigate: (id) => props.history.push(`/submissions/submission/${id}`)
  })

  return (
    <SubmissionsDashboard
      submissions={submissions}
      isLoading={isLoading}
      loadError={loadError}
      retryLoad={() => { setIsLoading(true); setReloadKey(reloadKey + 1) }}
      page={page}
      setPage={setPage}
      user={user}
      setFilters={setFilters}
      setNotFilters={setNotFilters}
      filters={filters}
      notFilters={notFilters}
      totalSubmissions={totalSubmissions}
      createSubmission={createSubmission}
      createQuickSubmission={createQuickSubmission}
      vendorUser={vendorUser}
      history={props.history}
      canQuickSubmit={canQuickSubmit}
      totalQuickSubmissions={totalQuickSubmissions}
    />
  )
}

export default SubmissionsDashboardContainer

